import { AfterBanksResponseProps } from "./_interfaces"

export const ModalLogo = ({
  bankSelected,
}: {
  bankSelected?: AfterBanksResponseProps
}): React.JSX.Element => {
  return (
    <div className='tw-flex tw-justify-start tw-gap-2 tw-items-center tw-w-full'>
      <img
        src={bankSelected?.imageSVG ?? bankSelected?.image}
        alt={`${bankSelected?.fullname} logo`}
        className='tw-col-span-1 tw-h-20 tw-w-32 tw-object-contain tw-justify-end tw-text-right tw-border tw-border-gray-50 tw-rounded-md'
      />
      <span className='tw-col-span-2 tw-text-left'>
        {`${bankSelected?.fullname}${
          bankSelected?.business === "1" ? " (Empresas)" : ""
        }`}
      </span>
    </div>
  )
}
